import script from "./sidebar-accounts-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-accounts-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__